var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 198,
    viewBox: "0 0 200 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 98.6209C0 153.001 44.8596 197.242 100 197.242C155.14 197.242 200 153.001 200 98.6209C200 44.241 155.142 0 100 0C44.8584 0 0 44.241 0 98.6209ZM100 179.606C54.7207 179.606 17.8838 143.277 17.8838 98.6209C17.8838 79.4646 24.6772 61.851 35.9952 47.9694L151.36 161.743C137.284 172.905 119.425 179.606 100 179.606ZM182.116 98.6209C182.116 117.777 175.323 135.391 164.006 149.272L48.6402 35.4988C62.7159 24.3369 80.5759 17.6371 100 17.6371C145.279 17.6371 182.116 53.9661 182.116 98.6209Z",
    fill: "black",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanIcon);
export default __webpack_public_path__ + "static/media/ban_icon.311f505a15ed4834aa87de6c9133d850.svg";
export { ForwardRef as ReactComponent };